module.exports = __webpack_public_path__ + "images/types-of-learning.png";